import React, { useState, useEffect, useMemo } from 'react';
import { FlatList, ScrollView, SectionList, View } from 'react-native'

import api from "@/utils/api"
import tw from '@/styles/tailwind';
import Text from '@/components/Text';
import { Image } from 'expo-image';
import { useQuery } from '@tanstack/react-query';

import dayjs from 'dayjs'
import IconButton from '@/components/IconButton';
import { currency } from '@/screens/Community/Admin/Fees/Reports/ReportsSection';
import { MonthSelector, MonthSelectorDropdown, MonthSelectorModal } from '@/components/Forms/MonthSelector';
import { useNavigation } from '@react-navigation/native';
import useActiveAdminCommunity from '@/hooks/useActiveAdminCommunity';
import ProviderRow from '@/screens/Vinte/Providers/components/ProviderRow';
import NewProviderModal from '@/screens/Vinte/Providers/NewProviderModal';


export default function ProvidersSection() {
  const { communityId } = useActiveAdminCommunity()
  const [showNewProviderModal, setShowNewProviderModal] = useState(false);

  const { isInitialLoading, error, data: providers, refetch } = useQuery({
    queryKey: ['vinte.providers', communityId],
    queryFn: () => api.get(`/vinte/providers?community_id=${communityId}`).then(response => response.data),
  })


  const navigation = useNavigation()

  return (

    <View style={tw`flex-1`}>
      {/* <View style={tw` bg-secondary`}>
        <View style={tw`bg-white px-5 py-4 mx-5 my-5 rounded-xl`}>
          <View style={tw`row justify-between mb-4`}>
            <Text style={tw`text-secondary text-base font-500`}>Total de gastos</Text>
            
            <MonthSelectorDropdown
              selectedDate={selectedMonth}
              onPress={() => setShowMonthSelectorModal(true)}
              style={{ container: `w-40 py-2`}}
            />
          </View>

          <Text style={tw`text-center text-2xl font-500 text-gray-400`}>{currency(periodTotal)}</Text>
        </View>
      </View> */}


      {/* Acá van los filtros */}

      {
        isInitialLoading &&
          <Text style={tw`my-8 text-lg text-center text-gray-400`}>Cargando...</Text>
      }


      {
        providers?.length == 0 &&
          <View style={tw``}>
            <Text style={tw`mt-25 text-lg text-center text-gray-400`}>Sin provedores registrados</Text>
            <Text style={tw`mt-3 text-center text-gray-400`}>Nuevo Proveedor</Text>
          </View>
      }

      <FlatList
        data={providers?.data}
        contentContainerStyle={tw`pt-2 pb-14`}
        renderItem={({ item }) => <ProviderRow provider={item} />}
        keyExtractor={(item) => item.uuid}
      />


      <IconButton
        title={"Nuevo proveedor"}
        color='secondary'
        textColor='white'
        style={tw`absolute right-0 bottom-0 w-full rounded-t-2xl rounded-b-0 py-3`}
        onPress={() => {
          setShowNewProviderModal(true)
        }}
      />


      {
        showNewProviderModal &&
          <NewProviderModal
            communityId={communityId}
            onRequestClose={() => setShowNewProviderModal(false)}
            onProviderCreated={() => {
              setShowNewProviderModal(false)
              refetch()
            }}
            visible
          />
      }
    </View>
  )
}